export {default} from './tenant-settings.vue'
